<template>
  <DraggableDialog
    :value="true"
    title="Cronograma do Projeto"
    subtitle="Visualize e gerencie o cronograma de todos os anos do projeto plurianual"
    initialWidth="1600"
    initialHeight="auto"
    maxHeight="80vh"
    @close="close"
    @input="onInput"
  >
    <div class="pa-4 pt-6">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>

      <div v-else>


        <div v-for="(item, index) in cronogramas" :key="index" class="mb-8">
          <h3 class="text-h6 font-weight-bold mb-3 primary--text">
             <v-icon left color="primary">mdi-calendar-range</v-icon>
             Ano-base: {{ item.ano_base }}
          </h3>
          <GanttProjetos
            :data="item.cronograma"
            :year="item.ano_base"
          ></GanttProjetos>
        </div>
        
        <div v-if="cronogramas.length === 0" class="text-center grey--text">
            Nenhum cronograma encontrado.
        </div>
      </div>
    </div>
  </DraggableDialog>
</template>

<script>
import { mapGetters } from "vuex";
import DraggableDialog from "@/components/DraggableDialog.vue";

export default {
  props: {
    anoBase: {
      type: Number,
      default: () => new Date().getFullYear()
    },
    benefit: {
      type: Number,
      default: null
    }
  },
  components: {
    GanttProjetos: () => import('./GanttProjetos.vue'),
    DraggableDialog
  },
  data() {
    return {
      cronogramas: [],
      loading: false,
    }
  },
  computed: {
    ...mapGetters(["clientId", "user"]),
    resource() {
      return this.apiResource(`/v1/projetos/${this.clientId}/cronograma`);
    },
  },
  methods: {
    fetchCronograma() {
      this.loading = true;
      const projetoId = this.$route.params.projetoId;
      
      let query = '';
      if (this.benefit) {
        query = `?trabalho=${this.benefit}`;
      }

      this.apiResource(`/v1/projetos/${this.clientId}/cronograma/${projetoId}/plurianual${query}`)
        .get()
        .then((response) => {
          this.cronogramas = response || [];
        })
        .catch(err => {
            console.error("Erro ao carregar cronograma plurianual", err);
            this.$notify({
                group: 'geral',
                title: 'Erro',
                text: 'Erro ao carregar cronograma.',
                type: 'error'
            });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.$emit('close');
    },
    onInput(val) {
      if (!val) this.close();
    }
  },
  watch: {
    benefit() {
      this.fetchCronograma();
    }
  },
  created() {
    this.fetchCronograma();
  },
  mounted() {},
  beforeDestroy() {}
}
</script>

<style lang="scss">
</style>